<template>
  <div class="uara-activity-view">
    <el-form ref="form" :model="form" label-width="140px" size="small" :rules="rules">
      <div class="white-container">
        <el-form-item label=" 俱乐部：" prop="clubName" style="width: 300px">
          <div class="flex-box">
            <img :src="form.logo" alt="" class="logo-box">
            <div> {{ form.clubName }}</div>
          </div>
        </el-form-item>

        <el-form-item label=" Leader姓名：" prop="leaderName" style="width: 300px">{{ form.leaderName }}</el-form-item>
        <el-form-item label=" 活动类型：" prop="eventType" style="width: 300px">
          <span v-if="form.eventType === 0">新手体验</span>
          <span v-else-if="form.eventType === 1">进阶训练</span>
          <span v-else-if="form.eventType === 2">以赛会友</span>
        </el-form-item>
        <el-form-item label=" 活动标题：" prop="name" style="width: 300px">{{ form.name }}</el-form-item>
        <el-form-item label=" 活动时间：" prop="beginTime" style="width: 300px">{{ form.beginTime }}</el-form-item>
        <el-form-item label=" 开放报名时间：" prop="registrationBeginTime" style="width: 300px">{{ form.registrationBeginTime }} </el-form-item>
        <el-form-item label=" 截止报名时间：" prop="registrationEndTime" style="width: 300px">{{ form.registrationEndTime }}</el-form-item>
        <el-form-item label=" 活动人数：" prop="participationNumber" style="width: 300px"> {{ form.participationNumber }} </el-form-item>
        <el-form-item label=" 候补人数：" prop="alternateTotalNumber" style="width: 300px"> {{ form.alternateTotalNumber }} </el-form-item>
        <el-form-item label=" 活动城市：" prop="region" style="width: 300px">{{ form.region }}</el-form-item>

        <div class="peopleNums">
          <el-form-item label="活动地点：" prop="address" style="width: 300px">
            {{ form.address }}
          </el-form-item>
          <div class="peopleNums-box">
            <el-button v-if="form.status == 5" size="small" type="primary" @click="openMap">
              点开地图
            </el-button>
            <el-form-item label="坐标" prop="location" style="width: 300px" label-width="80px">
              <el-input v-model="form.location" placeholder="请输入活动地点的经纬度" :readonly="form.status != 5" />
            </el-form-item>
          </div>
        </div>

        <el-form-item label="活动介绍：" prop="content" style="width: 80%">
          <el-input v-model="form.content" type="textarea" :rows="4" placeholder="请输入活动介绍" :readonly="form.status != 5" />
        </el-form-item>

        <el-form-item label="注意事项：" prop="announcement" style="width: 80%">
          <div style="white-space:pre-wrap" v-html="form.announcement" />
        </el-form-item>

        <div class="img-box">
          <div class="title">活动图片</div>
          <div v-if="form.activityImageVO" class="flex uploadImg-cont">
            <div v-for="item in imgList" :key="item.id" class="img-item">
              <template v-if="form.status === 5">
                <el-form-item :prop="'activityImageVO.' + item.text" label-width="0">
                  <UploadImage :url="form.activityImageVO[item.text]" save-path="rugby/activity/" :title="item.title" :size-tips="item.sizeTips" :show-replace="false" @upload="(url) => onImgUpload(item.text, url)" />
                </el-form-item>
              </template>
              <template v-else>
                <img :src="form.activityImageVO[item.text]" class="activity-img">
                <div class="text">{{ item.title }}</div>
              </template>
            </div>
          </div>
        </div>
      </div>

      <div class="flex btns   marginTop">
        <el-button v-if="form.status == 5" type="danger" @click="cancel">拒绝</el-button>
        <el-button v-if="form.status == 5" type="primary" @click="submit">通过</el-button>
        <el-button v-if="form.status != 5" type="primary" @click="goBack">返回</el-button>

      </div>

    </el-form>
    <Dialog v-if="formDialogShow" v-model="formDialogShow" :information="information" @submit-success="dialogSuccess" />
  </div>
</template>

<script>
import UploadImage from '@/components/UploadImage';
import { RugbyActivity } from '@/model/rugbyActivity';
// import { mapState } from 'vuex';
import Dialog from '@/components/Dialog';
export default {
  components: { UploadImage, Dialog },
  data() {
    return {
      form: new RugbyActivity(),
      rules: {
        location: [
          {
            required: true, validator: (rule, value, callback) => {
              if (this.form.status != 5) {
                callback();
              } else {
                if (value === '0,0') {
                  callback(new Error('请输入经纬度'));
                } else {
                  console.log('经纬度', value);
                  callback();
                }
              }
            }, trigger: 'blur',
          },
        ],
      },

      cancelText: "",
      information: {},
      disabled: false,

      formDialogShow: false,
      imgList: [
        { id: 1, title: '列表页图片', text: 'activityListPagePicture', sizeTips: '381px*561px' },
        { id: 2, title: '活动详情页头图', text: 'activityDetailsPageHeader', sizeTips: '1125px*1125px' },
        // { id: 3, title: '相关活动推荐图片', text: 'recommendedPcturesOfRelevantActivities' },
        // { id: 4, title: '我的活动列表图片', text: 'myActivityListPictures' },
        { id: 5, title: '分享海报', text: 'shareImage', sizeTips: '849px*849px' },
        { id: 6, title: '分享卡片', text: 'shareCardImage', sizeTips: '500px*400px' },
      ],
    };
  },
  computed: {},
  watch: {},

  created() {

  },
  mounted() {
    const { query } = this.$route;

    this.id = query.id;
    if (query.id) {
      this.cancelText = '查看';
      this.getUaraDetail(this.id);
    }
  },
  methods: {
    getUaraDetail(id) {
      this.$Api.rugby.activityDetail(id).then(res => {
        this.form = new RugbyActivity(res);
      });
    },

    goBack() {
      this.$router.go(-1);
    },

    // 拒绝
    cancel() {
      this.formDialogShow = true;
      this.information = {
        operation: 'cancel',
        icon: 'warn',
        subTitle: `是否确认拒绝该活动的申请？`,
      };
    },

    submit() {
      this.formDialogShow = true;
      this.information = {
        operation: "submit",
        icon: "warn",
        subTitle: "是否确认通过该活动的申请？",
      };
    },

    dialogSuccess(operation) {
      if (operation === 'cancel') { // 拒绝
        this.$Api.rugby.refuseId(this.id).then(res => {
          this.getUaraDetail(this.id);
        });
      } else if (operation === 'submit') {
        this.$refs.form.validate((valid) => {
          if (valid) {
            const datas = {
              id: this.id,
              longitude: this.form.longitude,
              latitude: this.form.latitude,
              content: this.form.content,
              activityImageVO: this.form.activityImageVO,
            };
            this.$Api.rugby.addFlagActivity(datas).then(res => {
              this.getUaraDetail(this.id);
            });
          } else {
            return false;
          }
        });
      }
    },

    openMap() {
      window.open('https://lbs.qq.com/getPoint/');
    },
    onImgUpload(key, url) {
      this.form.activityImageVO[key] = url;
    },
  },
};
</script>

<style lang="less" scoped>
.row-cont {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.marginTop {
  margin-top: 30px;
}
.btns {
  button {
    width: 120px;
    height: 50px;
  }
  align-items: center;
  justify-content: center;
}
</style>

<style lang="less">
.uara-activity-view {
  .peopleNums {
    min-width: 1000px;
    display: flex;
    align-items: flex-start;
    .peopleNums-box {
      display: flex;
      align-items: flex-start;
    }
    button {
      margin-left: 30px;
    }
  }
  .img-box {
    .title {
      margin-block: 16px;
    }

    .uploadImg-cont {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      .text {
        font-size: 14px;
        margin-top: 10px;
      }
    }

    .activity-img {
      width: 150px;
      height: 150px;
      border-radius: 6px;
      margin-right: 36px;
    }
  }

  .el-button--danger {
    background-color: #dc0019;
    border-color: #dc0019;
  }

  .flex-box {
    display: flex;
    align-items: center;
    height: 42px;
    .logo-box {
      width: 42px;
      height: 42px;
      border-radius: 50%;
      margin-right: 8px;
    }
  }

  .content-btn {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
